var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 42.3333H30.667C32.5003 42.3333 34.0003 40.8333 34.0003 39V22.3333H39.3003C42.267 22.3333 43.767 18.7333 41.667 16.6333L26.367 1.33334C25.067 0.0333374 22.967 0.0333374 21.667 1.33334L6.36699 16.6333C4.26699 18.7333 5.73366 22.3333 8.70033 22.3333H14.0003V39C14.0003 40.8333 15.5003 42.3333 17.3337 42.3333ZM4.00033 49H44.0003C45.8337 49 47.3337 50.5 47.3337 52.3333C47.3337 54.1667 45.8337 55.6667 44.0003 55.6667H4.00033C2.16699 55.6667 0.666992 54.1667 0.666992 52.3333C0.666992 50.5 2.16699 49 4.00033 49Z",
    fill: "#0072CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.f9f75ec89dc9994d6f4f19afb946f133.svg";
export { ForwardRef as ReactComponent };